import ChallengeConfirmation from '../../../screens/animations/challengeConfirmation';
import ChallengeSection from '../../../screens/animations/challengeSection';
import ChallengeSectionIntro from '../../../screens/animations/ChallengeSectionIntro';
import CircleTakeover from '../../../screens/animations/circleTakeover';
import MultipleChoiceScreen from '../../../screens/multipleChoice';

export const CHALLENGE_SCREENS = [
    {
        key: 'challenge section',
        trackingName: 'challenge section',
        screenName: 'challenge section',
        component: <ChallengeSection />
    },
    {
        key: 'challenge section intro',
        trackingName: 'challenge section intro',
        screenName: 'challenge section intro',
        component: <ChallengeSectionIntro />
    },
    {
        key: 'challenge flavours',
        trackingName: 'challenge flavours',
        screenName: 'challenge flavours',
        component: (
            <MultipleChoiceScreen
                hideProgress
                position={0}
                sectionKey={'challenge'}
                subtitle={'Choose your challenge experience, and you\'ll be matched with a group of others working towards the same goals:'}
                backJump={2}
            />
        )
    },
    {
        key: 'challenge confirmation',
        trackingName: 'challenge confirmation',
        screenName: 'challenge confirmation',
        component: <ChallengeConfirmation />
    },
    {
        key: 'challenge explainer',
        trackingName: 'challenge explainer',
        screenName: 'challenge explainer',
        component: (
            <CircleTakeover
                hideProgress
                position={0}
                sectionKey={'challenge'}
                title={'Now, let\'s finish setting up your Sunnyside profile'}
            />
        )
    }
];
